/**
 * Utilitário para reset global de contextos e estado da aplicação
 * Centraliza a lógica de limpeza de contexto para garantir consistência
 * em diferentes fluxos (pesquisa, clique no mapa, fechar PropertyView)
 */

/**
 * Função que realiza reset completo de todos os contextos e estados globais da aplicação
 *
 * @param {Object} mapContext - Objeto com setters do MapContext
 * @param {Function} mapContext.setPropertyData - Setter para dados da propriedade
 * @param {Function} mapContext.setGeometries - Setter para geometrias por fonte
 * @param {Function} mapContext.setThemeGeometries - Setter para geometrias por tema
 * @param {Function} mapContext.setPropertyCodes - Setter para códigos da propriedade
 * @param {Function} mapContext.setSidebarOpen - Setter para estado de abertura da PropertyView
 * @param {Function} mapContext.setMarker - Setter para marcador no mapa
 * @param {Object} filterContext - Objeto com setters do PropertyFilterContext
 * @param {Function} filterContext.setSelectedCarCodes - Setter para códigos CAR selecionados
 * @param {Function} filterContext.setSelectedSigefCodes - Setter para códigos SIGEF selecionados
 * @param {boolean} closeSidebar - Se true, fecha a PropertyView
 * @param {boolean} resetMarker - Se true (padrão), limpa o marcador no mapa
 */
export const resetGlobalContext = (
  mapContext,
  filterContext,
  closeSidebar = false,
  resetMarker = true,
) => {
  // Reset do MapContext
  if (mapContext) {
    // Reset dos dados da propriedade
    if (mapContext.setPropertyData) {
      //console.log('[contextResetUtils] Resetando propertyData');
      mapContext.setPropertyData(null);
    }

    // Reset das geometrias
    if (mapContext.setGeometries) {
      //console.log('[contextResetUtils] Resetando geometrias');
      mapContext.setGeometries([]);
    }

    // Reset das geometrias por tema
    if (mapContext.setThemeGeometries) {
      //console.log('[contextResetUtils] Resetando themeGeometries');
      mapContext.setThemeGeometries({});
    }

    // Reset dos códigos de propriedade
    if (mapContext.setPropertyCodes) {
      //console.log('[contextResetUtils] Resetando propertyCodes');
      mapContext.setPropertyCodes({
        car: [],
        sigef: [],
        parcela: [],
        filename: null,
      });
    }

    // Reset do marcador no mapa (somente se resetMarker for true)
    if (resetMarker && mapContext.setMarker) {
      //console.log('[contextResetUtils] Resetando marcador no mapa');
      mapContext.setMarker(null);
    } else if (!resetMarker) {
      //console.log('[contextResetUtils] Preservando marcador no mapa conforme solicitado');
    }

    // Fechar PropertyView se solicitado
    if (closeSidebar && mapContext.setSidebarOpen) {
      //console.log('[contextResetUtils] Fechando PropertyView');
      mapContext.setSidebarOpen(false);
    }
  }

  // Reset do PropertyFilterContext
  if (filterContext) {
    // Reset dos códigos CAR selecionados
    if (filterContext.setSelectedCarCodes) {
      //console.log('[contextResetUtils] Resetando selectedCarCodes');
      filterContext.setSelectedCarCodes([]);
    }

    // Reset dos códigos SIGEF selecionados
    if (filterContext.setSelectedSigefCodes) {
      //console.log('[contextResetUtils] Resetando selectedSigefCodes');
      filterContext.setSelectedSigefCodes([]);
    }
  }

  //console.log('[contextResetUtils] Reset global de contexto concluído');
};
